import React from 'react';
import { Link } from 'react-router-dom';
import { allProductsData } from '../data/products';
import './Equipment.css';

const Equipment = () => {
    // Take the first 6 products for the homepage equipment section
    const displayProducts = allProductsData.slice(0, 6);

    return (
        <section className="equipment-section" id="products">
            <div className="equipment-container">

                <div className="equipment-header">
                    <div>
                        <span className="section-subtitle">EQUIPMENT</span>
                        <h2 className="section-title">Our Physiotherapy &<br />Rehabilitation Equipment</h2>
                    </div>
                    <div>
                        <Link to="/products" className="view-all-btn">View All Products</Link>
                    </div>
                </div>

                <div className="equipment-grid">
                    {displayProducts.map(product => {
                        const heightRange = product.specs.find(s => s.label.includes('HEIGHT'))?.value || 
                                           product.detailedSpecs?.find(s => s.label.includes('Height'))?.value;
                        
                        return (
                            <Link to={`/product/${product.slug || product.id}`} className="product-card" key={product.id} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className="product-image-wrapper">
                                    <div className="product-image-container">
                                        <img src={product.image} alt={product.title} />
                                    </div>
                                    <div className="view-icon-btn" aria-label="View Details">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="7" y1="17" x2="17" y2="7"></line>
                                            <polyline points="7 7 17 7 17 17"></polyline>
                                        </svg>
                                    </div>
                                </div>
                                
                                <div className="product-details-content">
                                    <div className="product-details-header">
                                        <h3 className="product-name">{product.title}</h3>
                                        {heightRange && (
                                            <div className="height-range-info">
                                                <span className="info-label">Height Range</span>
                                                <span className="info-value">{heightRange.split('[cite:')[0]}</span>
                                            </div>
                                        )}
                                    </div>
                                    
                                    <ul className="product-features-list">
                                        {(product.keyFeatures || []).slice(0, 5).map((feature, idx) => (
                                            <li key={idx}>
                                                <span className="bullet">•</span>
                                                {feature.split('[cite:')[0].trim()}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Link>
                        );
                    })}
                </div>

            </div>
        </section>
    );
};

export default Equipment;
